import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Grid,
  Card,
} from "@mui/material";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import EmptyData from "components/EmptyData";
import { getDatabase, ref, get, remove } from "firebase/database";
import PushnotificationDialogBox from "../../DialogBox/pushnotification";
import socketService from "../../socket/SocketService";
import Pushnotificationupdateapp from "../../DialogBox/pushnotificationupdateapp";
const PushNotification = () => {
  const [allData, setAllData] = useState([]);
  const [open, setOpen] = useState(false);
  const [openVideo, setOpenVideo] = useState(false);
  const [selectedNotification, setselectedNotification] = useState({});

  const navigate = useNavigate();

  const close = () => {
    setOpen(false);
    getData();
  };
  const openModal = () => {
    setOpen(true);
  };
  const deleteNotification = (notification) => {
    // console.log(notification);
    const database = getDatabase();
    const notificationRef = ref(database, `/pushnotification/${notification.id}`);

    remove(notificationRef)
      .then((data) => {
        //   console.log(data);
        toast.info(`Notification removed !`, {
          autoClose: 3000,
          position: toast.POSITION.TOP_CENTER,
        });
        getData();
      })
      .catch((error) => {
        //  console.error("Error deleting vehicle:", error);
      });
  };

  const edit = (notification) => {
    // console.log(notification);
    setselectedNotification(notification);
    setOpen(true);
  };
  const sendVideoAlert = () => {
    socketService.emit("newvideoalert");
    toast.info(`Video alert sent !`, {
      autoClose: 3000,
      position: toast.POSITION.TOP_CENTER,
    });
  };
  const getData = () => {
    // console.log("get data...");
    const db = getDatabase();
    const dbRef = ref(db, "pushnotification");
    get(dbRef).then((snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        // console.log("data", data);
        const mergedData = Object.entries(data).map(([key, value]) => ({
          id: key,
          ...value,
        }));
        setAllData(mergedData);
      } else {
        setAllData([]);
      }
    });
  };

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user) {
      navigate("/authentication/sign-in");
    }
    getData();
  }, []);

  return (
    <DashboardLayout>
      {open && (
        <PushnotificationDialogBox
          open={open}
          onClose={close}
          notification={selectedNotification}
        />
      )}

      {openVideo && (
        <Pushnotificationupdateapp open={openVideo} onClose={() => setOpenVideo(false)} />
      )}
      <MDBox pt={12} pb={3}>
        <Grid container spacing={6} style={{ position: "relative", minHeight: "60vh" }}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <MDTypography
                  variant="h6"
                  color="white"
                  sx={{
                    fontWeight: "bold",
                    fontSize: "1.5rem",
                  }}
                >
                  PUSH NOTIFICATION DASHBOARD
                </MDTypography>
              </MDBox>

              <button
                className="btn btn-warning"
                style={{ fontWeight: "bold", width: 150, marginTop: 20, marginLeft: 20 }}
                onClick={() => setOpenVideo(true)}
              >
                New Version Update
              </button>

              <div
                style={{
                  display: "flex",
                  "place-content": "space-between",
                }}
              >
                <button
                  className="btn btn-success mt-2 ms-3 mb-3"
                  style={{ width: 200 }}
                  onClick={() => openModal()}
                >
                  ADD
                </button>
                <button
                  className="btn btn-success mt-2 ms-3 mb-3"
                  style={{ width: 200 }}
                  onClick={() => sendVideoAlert()}
                >
                  SEND NEW VIDEO ALERT
                </button>
              </div>

              {allData ? (
                <MDBox>
                  <TableContainer component={Paper}>
                    <Table
                      aria-label="user table"
                      sx={{ "& td, & th": { fontSize: "14px", padding: "8px" } }}
                    >
                      <TableBody>
                        <TableRow>
                          <TableCell
                            align="center"
                            className="rounded"
                            sx={{ padding: "6px", color: "black", fontWeight: "bold" }}
                          >
                            Title
                          </TableCell>
                          <TableCell
                            align="center"
                            className="rounded"
                            sx={{ padding: "6px", color: "black", fontWeight: "bold" }}
                          >
                            Body
                          </TableCell>

                          <TableCell
                            align="center"
                            className="rounded"
                            sx={{ padding: "6px", color: "black", fontWeight: "bold" }}
                          >
                            Action
                          </TableCell>
                        </TableRow>
                      </TableBody>
                      {allData.map((notification, index) => (
                        <TableRow key={index} sx={{ height: "auto" }}>
                          <TableCell align="center" className="rounded" sx={{ padding: "6px" }}>
                            {notification.title}
                          </TableCell>

                          <TableCell align="center" className="rounded" sx={{ padding: "6px" }}>
                            {notification.body}
                          </TableCell>

                          <TableCell align="center" className="rounded" sx={{ padding: "6px" }}>
                            <button
                              className="btn btn-success ms-4 mb-2"
                              style={{ width: "120px" }}
                              onClick={() => edit(notification)}
                            >
                              Edit
                            </button>
                            <button
                              className="btn btn-danger ms-4 mb-2"
                              style={{ width: "120px" }}
                              onClick={() => deleteNotification(notification)}
                            >
                              Delete
                            </button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </Table>
                  </TableContainer>
                </MDBox>
              ) : (
                <EmptyData />
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
};
export default React.memo(PushNotification);
